import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import useHttp from "../../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";

const StationwiseTargets = () => {
  const frmRef = useRef({});

  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);

  const [collectionCenterId, setCollectionCenterId] = useState();
  const [collecticnCenterdata, setCollectionCenter] = useState([]);
  const [data, setData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const { sendRequest: getWarehouseData } = useHttp();

  const [cropAreaData, setCropAreaData] = useState([]);

  const [cropwiseAreaCovered, setcropwiseAreaCovered] = useState([]);
  const [executivewiseProcurement, setexecutivewiseProcurement] = useState([]);
  const [executivewiseAreaCovered, setexecutivewiseAreaCovered] = useState([]);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange",e.target.value)
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate",toDate)

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const { sendRequest: getfarmerdeal } = useHttp();

  const loadCountData = (id) => {
    fillprocurementData(id);
  };

  const fillprocurementData = (employeeId, regionId) => {
    var newList = [];

    var urlfilter = "";

    var urlfilter = "";

    // urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
    // urlfilter = urlfilter + `&toDate=${selectedToDate}`;

    urlfilter =
      urlfilter +
      `&fromDate=${moment(frmRef.current.fromDate.value).format("DD/MM/YYYY")}`;

    urlfilter =
      urlfilter +
      `&toDate=${moment(frmRef.current.toDate.value).format("DD/MM/YYYY")}`;

    // console.log("urlfilter", urlfilter);

    if (employeeId > 0) {
      urlfilter = `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }

    var url = `/api/staionwiseTargetsDetail/?orgId=${localStorage.getItem(
      "orgId"
    )}&&empId=${localStorage.getItem(
      "empId"
    )} ${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        //console.log("reportdata", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    fillprocurementData(0, 0);
  }, [getprocurementData]);

  const fieldsToExport = [
    "stationName",
    "totalArea",
    "plotUnit",
    "totalTargetSeedlings",
    "totalTargetYield",
  ];

  const customHeaders = [
    "Station Name",
    "Total Area",
    "Plot Unit",
    "Total Target Seedlings",
    "Total Target Yield",
  ];

  const handleExportExcel = () => {
    const filename = "StaionwiseTargetsDetail.xlsx";
    //console.log(fieldsToExport,customHeaders);

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Stationwise Targets Report
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row"></div>
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Region</label>
                  <select
                    id="regionId"
                    className="form-control"
                    ref={(el) => (frmRef.current["regionId"] = el)}
                    value={regionId}
                    onChange={(e) => {
                      var regid = 0;

                      if (e.target.value != "--Select--") {
                        regid = e.target.value;
                      }
                      setRegionId(regid);
                      EmployeeDetail(regid);
                      setEmployeeId(0);
                      setData([]);
                    }}
                  >
                    <option>--Select--</option>
                    {regionData &&
                      regionData.map((x) => (
                        <option
                          key={x.regionId}
                          user-id={x.regionId}
                          value={x.regionId}
                        >
                          {x.regionName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option>--Select--</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    ref={(el) => (frmRef.current["fromDate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor={"to_date"}>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    ref={(el) => (frmRef.current["toDate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillprocurementData(employeeId, regionId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered  text-center table-sm">
                      <thead>
                        <tr className="tableheaderrowview">
                            <th>Station Name</th>
                          <th>Total Area</th>
                          <th>Plot Unit</th>
                          <th>Total Target Seedlings</th>
                          <th>Total Target Yield</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.stationName}</td>
                                <td>{itm.totalArea}</td>
                                <td>{itm.plotUnit}</td>
                                <td>{itm.totalTargetSeedlings}</td>
                                <td>{itm.totalTargetYield}</td>
                       
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default StationwiseTargets;
